import DOMPurify from 'dompurify';
import React from 'react';

export const HTMLSanitizer = ({ text }: { text: string }) => {
  return (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        // eslint-disable-next-line @typescript-eslint/naming-convention
        __html: DOMPurify.sanitize(text ?? ''),
      }}
    />
  );
};
